import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import {
  projectApiStore,
  identifierSaveStore,
  getProjectApiStore,
} from "@/hooks";
import { TextButton, FlexBox } from "@/components/common";
import {
  ProjectFilesUploader,
  ProjectIdentifierInput,
} from "@/components/project/save";


/**
 * Inputs for creating or editing a project.
 */
const __default__ = {
  name: "SaveProjectInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["save"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const identifier = computed(() => identifierSaveStore.editedIdentifier);
const isUpdate = computed(() => identifierSaveStore.isUpdate);
const canSave = computed(() => identifierSaveStore.canSave);
const loading = computed(() => projectApiStore.saveProjectLoading);

/**
 * Saves the project being edited.
 */
function handleSave(): void {
  projectApiStore.handleSave({
    onSuccess: async () => {
      emit("save");

      await getProjectApiStore.handleLoadProjects();
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isUpdate.value)
      ? (_openBlock(), _createBlock(_unref(ProjectFilesUploader), {
          key: 0,
          "data-cy-name": "input-project-name-modal",
          "data-cy-description": "input-project-description-modal",
          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (emit('save')))
        }))
      : (_openBlock(), _createBlock(_unref(ProjectIdentifierInput), {
          key: 1,
          name: identifier.value.name,
          "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((identifier.value.name) = $event)),
          description: identifier.value.description,
          "onUpdate:description": _cache[2] || (_cache[2] = ($event: any) => ((identifier.value.description) = $event)),
          "is-update": "",
          "data-cy-name": "input-project-name-modal",
          "data-cy-description": "input-project-description-modal"
        }, null, 8, ["name", "description"])),
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      justify: "end"
    }, {
      default: _withCtx(() => [
        (isUpdate.value)
          ? (_openBlock(), _createBlock(_unref(TextButton), {
              key: 0,
              color: "primary",
              label: "Save",
              disabled: !canSave.value,
              loading: loading.value,
              "data-cy": "button-project-save",
              onClick: handleSave
            }, null, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})